import { Controller } from "@hotwired/stimulus";

// Copies the source target's text, e.g. a suggested AI prompt on the
// artwork guide, and briefly confirms on the button.
export default class extends Controller {
  static targets = ["source", "button"];
  static values = { copied: String };

  connect() {
    this.label = this.buttonTarget.textContent;
  }

  disconnect() {
    clearTimeout(this.reset);
    this.buttonTarget.textContent = this.label;
  }

  async copy() {
    const text = this.sourceTarget.innerText.trim();
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      return;
    }

    // A second click within the delay restarts it rather than saving
    // "Copied" as the label.
    clearTimeout(this.reset);
    this.buttonTarget.textContent = this.copiedValue;
    this.reset = setTimeout(() => {
      this.buttonTarget.textContent = this.label;
    }, 2000);
  }
}
